export const formatDisplayDate = (
  value: string | null | undefined,
): string => {
  const parsed = parseDobString(value);
  return parsed ? parsed.toLocaleDateString() : "-";
};

export const parseDobString = (dob: string | null | undefined): Date | null => {
  if (!dob) return null;
  const newFormat = dob.match(/(\d+)\/<(\d+)>\/(\d+)/);
  if (newFormat) {
    const [, day, month, year] = newFormat.map(Number);
    const date = new Date(year, month - 1, day);
    return isNaN(date.getTime()) ? null : date;
  }
  const parts = dob.split("/");
  if (parts.length !== 3) return null;
  const [day, month, year] = parts.map(Number);
  const date = new Date(year, month - 1, day);
  return isNaN(date.getTime()) ? null : date;
};
